import { render, staticRenderFns } from "./signUpC.vue?vue&type=template&id=6206210c&"
import script from "./signUpC.vue?vue&type=script&lang=js&"
export * from "./signUpC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports